<p-toast [baseZIndex]="1000" position="top-right"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5">
    <form [formGroup]="entidadeForm" autocomplete="off">
      <div class="row">
        <div class="col-md-6">
          <lib-page-header page-title="LOCALIZAÇÕES" page-subtitle="EXERCÍCIO: {{login.exercicio.ano}}"
            image-title="assets/img/limited-stock.png">
          </lib-page-header>
        </div>
        <div class="col-md-6">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/produto-localizacoes']" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <button (click)="submitForm()" class="btn btn-outline-info btn-sm float-right mr-4">
            Salvar
          </button>
        </div>
      </div>
      <hr class="mt-1 mb-2" />
      <div class="project-tab">
        <div class="form-row">
          <div class="col-md-12">
            <div class="tab-pane fade show active" id="principal" role="tabpanel" aria-labelledby="principal-tab">
              <div class="form-row pt-3">
                <div class="col-sm-8">
                  <div class="form-row">
                    <div class="form-group col-md-3">
                      <label for="sala">Sala<span class="text-danger">*</span></label>
                      <input #sala_ id="sala" formControlName="sala" type="text" class="form-control">
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label for="armario">Armário<span class="text-danger">*</span></label>
                      <input id="armario" formControlName="armario" type="text" class="form-control font-weight-bold">
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label for="prateleira">Prateleira<span class="text-danger">*</span></label>
                      <input id="prateleira" formControlName="prateleira" type="text" class="form-control">
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label for="produto">Produto</label>
                      <p-autoComplete formControlName="produto" [field]="produtoAutoComplete.conversor"
                        [suggestions]="produtoAutoComplete.lista" (completeMethod)="produtoAutoComplete.filtrar($event)"
                        placeholder="Informe o nome so produto" inputStyleClass="form-control font-weight-bold"
                        minLength="2" [style]="{ width: '100%' }" [forceSelection]="true" [autoHighlight]="true"
                        *ngIf="produtoAutoComplete">
                        <ng-template let-produto pTemplate="item">
                          {{produto.codigo}} {{produto.nome}}
                        </ng-template>
                      </p-autoComplete>
                    </div>
                  </div>
                </div>                
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr class="mt-2 mb-4" />
      <div class="row">
        <div class="col-12">
          <button (click)="submitForm(true)" class="btn btn-sm btn-outline-info">
            <img src="assets/img/global/tick.png" alt="salvar" height="20" width="20">
            Salvar & novo
          </button>
        </div>
      </div>
    </form>
  </div>
</div>